import { render, staticRenderFns } from "./EventRecordDetailsPopout.vue?vue&type=template&id=aa71bc30&scoped=true"
import script from "./EventRecordDetailsPopout.vue?vue&type=script&lang=ts"
export * from "./EventRecordDetailsPopout.vue?vue&type=script&lang=ts"
import style0 from "./EventRecordDetailsPopout.vue?vue&type=style&index=0&id=aa71bc30&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa71bc30",
  null
  
)

export default component.exports